// redux
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
// types
import { AnimationScreen, AnimationScreensState } from "../types/selectedScreensTypes";

const initialState: AnimationScreensState = {
  screens: [],
};

const animationScreensSlice = createSlice({
  name: "animationScreens",
  initialState,
  reducers: {
    addScreen: (state, action: PayloadAction<AnimationScreen>) => {
      state.screens.push(action.payload);
    },
    removeScreen: (state, action: PayloadAction<number>) => {
      state.screens = state.screens.filter(
        (screen) => screen.id !== action.payload,
      );
    },
    clearSelectedScreens: (state) => {
      state.screens = [];
    },
    updateAllScreensSavedStatus: (state, action: PayloadAction<boolean>) => {
      state.screens = state.screens.map((screen) => ({
        ...screen,
        is_saved: action.payload,
        is_saved_pk: action.payload ? screen.is_saved_pk : null,
      }));
    },
    updateScreensSavedPointIds: (
      state,
      action: PayloadAction<Record<number, number>>,
    ) => {
      state.screens = state.screens.map((screen) => {
        if (action.payload[screen.id]) {
          return {
            ...screen,
            is_saved: true,
            is_saved_pk: action.payload[screen.id],
          };
        }
        return screen;
      });
    },
  },
});

export const { actions: animationScreensActions, reducer: animationScreensReducer } =
  animationScreensSlice; 